import React, { useRef } from "react";
import { Drawer } from 'vaul';
import NewAddNPI from "../UI/NewAddNPI";
import { X } from "lucide-react";

export default function AddAndEditNPIModal({
  openModal = false,
  setOpenModal = () => {},
  account_id,
  location_id,
  handleNPIAction = () => {},
  npiActionLoader = false,
  previousScrollPosition = 0,
  editModal = false,
  selectedNPI = {},
  manageInsurance = false,
}) {
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose} dismissible={false}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4" onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
            <Drawer.Title className="sr-only">{editModal ? "Edit" : "Add"} NPI</Drawer.Title>
            <Drawer.Description className="sr-only">{editModal ? "Edit" : "Add"} a new NPI</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
              <div className="docpro_modal">
                <button
                  className="docpro_close_btn"
                  onClick={() => handleDrawerClose()}
                >
                  <X />
                </button>

                <NewAddNPI
                  account_id={account_id}
                  location_id={location_id}
                  manageInsurance={manageInsurance}
                />
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
